import { Directive, input, computed } from '@angular/core';

const ANIMATION_CLASS_MAP = {
  pulse: 'skeleton-animation-pulse',
  wave: 'skeleton-animation-wave',
  none: 'skeleton-animation-none',
} as const;

@Directive({
  selector: '[psSkeletonLoader]',
  standalone: true,
  host: {
    '[class]': 'hostClasses()',
    '[style.width]': 'hostWidth()',
    '[style.height]': 'hostHeight()',
    '[attr.aria-busy]': 'isLoading()',
    '[attr.aria-live]': 'isLoading() ? "polite" : null',
    '[attr.aria-hidden]': 'isLoading()',
  },
})
export class SkeletonLoaderDirective {
  public readonly isLoading = input(false, { alias: 'psSkeletonLoader' });
  public readonly animation = input<keyof typeof ANIMATION_CLASS_MAP>('pulse');
  public readonly loaderWidth = input<string>();
  public readonly loaderHeight = input<string>();

  protected readonly hostClasses = computed(() => {
    if (!this.isLoading()) {
      return [];
    }

    return ['skeleton-loading', ANIMATION_CLASS_MAP[this.animation()]];
  });

  protected readonly hostWidth = computed(() =>
    this.isLoading() ? this.loaderWidth() : undefined,
  );

  protected readonly hostHeight = computed(() =>
    this.isLoading() ? this.loaderHeight() : undefined,
  );
}
